(() => {
  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  function revealAndPlace(node, target, mode = 'after') {
    if (!node) return;
    if (target) {
      if (mode === 'before') target.before(node);
      else target.after(node);
    }
    node.hidden = false;
  }

  function placeHomepageModules() {
    const category = qs('#fmp-category-strip');
    const discovery = qs('#fmp-discovery');
    const tools = qs('#fmp-tools');
    if (!category && !discovery && !tools) return;

    const main = qs('#MainContent');
    const marquee = qs('[id*="marquee_9FMfMG"]', main || document);
    const hero = qs('[id*="section_cgncgd"]', main || document);
    const firstFeatured = qs('[id*="featured_collection_36URdR"]', main || document);

    if (category) {
      if (marquee) revealAndPlace(category, marquee, 'after');
      else if (hero) revealAndPlace(category, hero, 'before');
      else { category.hidden = false; if (main) main.prepend(category); }
    }

    if (discovery) {
      if (hero) revealAndPlace(discovery, hero, 'after');
      else { discovery.hidden = false; if (main) main.prepend(discovery); }
    }

    if (tools) {
      if (firstFeatured) revealAndPlace(tools, firstFeatured, 'after');
      else { tools.hidden = false; if (main) main.append(tools); }
    }
  }

  function formatTry(amountInCents) {
    try {
      return new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY',
        maximumFractionDigits: 2
      }).format(amountInCents / 100);
    } catch (_) {
      return `${(amountInCents / 100).toFixed(2)} TL`;
    }
  }

  async function updateShippingProgress() {
    const box = qs('[data-fmp-shipping]');
    if (!box) return;
    const threshold = Number(box.dataset.threshold || 150000);
    const text = qs('[data-fmp-shipping-text]', box);
    const fill = qs('[data-fmp-shipping-progress]', box);
    const progress = qs('[role="progressbar"]', box);

    try {
      const response = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('cart');
      const cart = await response.json();
      const total = Number(cart.total_price || 0);
      const percent = Math.max(0, Math.min(100, (total / threshold) * 100));
      if (fill) fill.style.width = `${percent}%`;
      if (progress) progress.setAttribute('aria-valuenow', String(Math.min(total, threshold)));
      if (text) {
        if (total >= threshold) text.textContent = 'Ücretsiz kargoyu kazandınız.';
        else if (total > 0) text.textContent = `Ücretsiz kargoya ${formatTry(threshold - total)} kaldı.`;
        else text.textContent = 'Sepetine ürün ekledikçe ilerlemeyi burada görebilirsin.';
      }
    } catch (_) {
      if (text) text.textContent = 'Ücretsiz kargo eşiği: 1.500 TL.';
    }
  }

  function scheduleShippingProgress() {
    if (!qs('[data-fmp-shipping]')) return;

    const runWhenIdle = () => {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(() => updateShippingProgress(), { timeout: 1500 });
      } else {
        window.setTimeout(() => updateShippingProgress(), 250);
      }
    };

    if (document.readyState === 'complete') runWhenIdle();
    else window.addEventListener('load', runWhenIdle, { once: true });
  }

  function initTabs() {
    const tabs = qsa('[data-fmp-tab]');
    const panels = qsa('[data-fmp-panel]');
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const key = tab.dataset.fmpTab;
        tabs.forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
        panels.forEach((panel) => { panel.hidden = panel.dataset.fmpPanel !== key; });
      });
    });
  }

  function numberValue(selector) {
    const value = Number.parseFloat(qs(selector)?.value || '');
    return Number.isFinite(value) ? value : null;
  }

  function initCalculators() {
    const count = qs('[data-fmp-count]');
    const grams = qs('[data-fmp-grams]');
    const fragrance = qs('[data-fmp-fragrance]');
    const waxResult = qs('[data-fmp-wax-result]');
    const fragranceResult = qs('[data-fmp-fragrance-result]');

    const calculateProduction = () => {
      const c = numberValue('[data-fmp-count]');
      const g = numberValue('[data-fmp-grams]');
      const f = numberValue('[data-fmp-fragrance]');
      if (waxResult) waxResult.textContent = c && g ? `${(c * g).toLocaleString('tr-TR', { maximumFractionDigits: 1 })} g` : '—';
      if (fragranceResult) fragranceResult.textContent = c && g && f !== null ? `${(c * g * f / 100).toLocaleString('tr-TR', { maximumFractionDigits: 1 })} g` : '—';
    };
    [count, grams, fragrance].filter(Boolean).forEach((input) => input.addEventListener('input', calculateProduction));

    const stock = qs('[data-fmp-stock]');
    const yieldGrams = qs('[data-fmp-yield-grams]');
    const yieldResult = qs('[data-fmp-yield-result]');
    const calculateYield = () => {
      const s = numberValue('[data-fmp-stock]');
      const g = numberValue('[data-fmp-yield-grams]');
      if (yieldResult) yieldResult.textContent = s && g ? `${Math.floor(s / g)} adet` : '—';
    };
    [stock, yieldGrams].filter(Boolean).forEach((input) => input.addEventListener('input', calculateYield));

    const wickButton = qs('[data-fmp-wick-plan]');
    if (wickButton) {
      wickButton.addEventListener('click', () => {
        const wax = qs('[data-fmp-wick-wax]')?.value || 'seçtiğin wax';
        const diameter = numberValue('[data-fmp-wick-diameter]');
        const output = qs('[data-fmp-wick-output]');
        if (!output) return;
        if (!diameter) {
          output.hidden = false;
          output.textContent = 'Kap iç çapını mm olarak gir.';
          return;
        }
        output.hidden = false;
        output.innerHTML = `<strong>${wax} · ${Math.round(diameter)} mm kap</strong><br>Uyumlu bir fitil serisinden başlangıç boyunu seçip bir alt ve bir üst boyla üçlü yanma testi yap. Erime havuzu, alev yüksekliği, islenme ve kap ısısını birlikte değerlendir. <a href="/collections/mum-fitilleri-ve-tutacaklar">Fitilleri incele →</a>`;
      });
    }
  }

  function initQuickOrder() {
    const form = qs('[data-fmp-quick-order]');
    if (!form) return;
    const message = qs('[data-fmp-quick-message]', form);

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const items = qsa('[data-fmp-quick-qty]', form)
        .map((input) => ({ id: Number(input.dataset.variantId), quantity: Math.max(0, Math.floor(Number(input.value || 0))) }))
        .filter((item) => item.id && item.quantity > 0);

      if (!items.length) {
        if (message) message.textContent = 'Sepete eklenecek en az bir ürün için adet gir.';
        return;
      }

      const submit = qs('button[type="submit"]', form);
      if (submit) { submit.disabled = true; submit.textContent = 'Sepete ekleniyor…'; }
      if (message) message.textContent = '';

      try {
        const response = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('add');
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      } catch (_) {
        if (message) message.textContent = 'Ürünler sepete eklenemedi. Lütfen adetleri kontrol edip tekrar dene.';
        if (submit) { submit.disabled = false; submit.textContent = 'Seçilenleri sepete ekle'; }
      }
    });
  }

  function placeProductSupport() {
    const support = qs('#fmp-product-support');
    if (!support) return;
    const grid = qs('.product-information__grid');
    if (grid) grid.after(support);
    support.hidden = false;
  }

  function init() {
    placeHomepageModules();
    initTabs();
    initCalculators();
    initQuickOrder();
    placeProductSupport();
    scheduleShippingProgress();
  }

  init();
})();